import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const findCleanerById = async (cleanerId: string) => {
  return await apiClient.get(`${ENDPOINTS.CLEANERS}/${cleanerId}`);
};
